import { Profiler, useEffect } from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'

import { launchErrorPopUp } from '@src/components/modals/ErrorPopUpModal/index'
import * as PATH from '@src/configs/paths'
import { ConfigLoadingStatus } from '@src/enums'
import Layout from '@src/layouts/Layout'
import { ExchangePage, OrdersPage, StatsPage } from '@src/pages'
import { ExchangeDataProvider } from '@src/pages/Exchange/context/ExchangeDataContext'
import { ExchangeStateProvider } from '@src/pages/Exchange/context/ExchangeStateContext'
import PointsPage from '@src/pages/Points'
import { logger } from '@src/utils/logger'
import { useConfigStore } from '@src/zustand_stores'

const PROFILE_EXCHANGE_PAGE = false

const AppRoutes = () => {
    const getConfig = useConfigStore(state => state.getConfig)
    const loading = useConfigStore(state => state.loading)

    useEffect(() => {
        // Load configuration only once when the app mounts
        if (loading === ConfigLoadingStatus.loading_not_yet_started) {
            getConfig()
        }
    }, [])

    return (
        <Layout>
            <Routes>
                <Route
                    path={PATH.LANDING} // Instantly replace the app state to PATH.SWAP
                    element={<Navigate to={PATH.SWAP} replace />}
                />
                <Route
                    path={PATH.SWAP}
                    element={
                        PROFILE_EXCHANGE_PAGE ? (
                            <Profiler id='ExchangePage was' onRender={onRenderCallback}>
                                <ExchangeStateProvider>
                                    <ExchangeDataProvider>
                                        <ExchangePage />
                                    </ExchangeDataProvider>
                                </ExchangeStateProvider>
                            </Profiler>
                        ) : (
                            <ExchangeStateProvider>
                                <ExchangeDataProvider>
                                    <ExchangePage />
                                </ExchangeDataProvider>
                            </ExchangeStateProvider>
                        )
                    }
                />
                <Route path={PATH.ORDERS} element={<OrdersPage />} />
                <Route path={PATH.POINTS} element={<PointsPage />} />
                <Route path={PATH.STATS} element={<StatsPage />} />

                {/* catch-all route redirect to swap page */}
                <Route path='*' element={<Navigate to={PATH.LANDING} replace />} />
            </Routes>
            <launchErrorPopUp.ErrorPopupWrapper />
        </Layout>
    )
}

const onRenderCallback: React.ProfilerOnRenderCallback = (id: any, phase: any, actualDuration: any) => {
    logger.debug(`${id} rendered in ${phase} phase: ${actualDuration}ms`)
}

export default AppRoutes
